"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountMenuItemLink = exports.AccountMenuItemText = exports.AccountMenuItem = void 0;
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const react_2 = require("@headlessui/react");
function AccountMenuItem(_a) {
    var { className, children } = _a, props = __rest(_a, ["className", "children"]);
    return (react_1.default.createElement(react_2.Menu.Item, Object.assign({ as: "li", className: (0, classnames_1.default)('mt-3 bg-white whitespace-nowrap text-sm w-full', className) }, props), children));
}
exports.AccountMenuItem = AccountMenuItem;
function AccountMenuItemText(_a) {
    var { className, children } = _a, props = __rest(_a, ["className", "children"]);
    return (react_1.default.createElement("p", Object.assign({ className: (0, classnames_1.default)('mt-3 bg-white whitespace-nowrap text-sm', 'text-gray-74 italic pb-1 border-b-1 border-gray-b w-full', className) }, props), children));
}
exports.AccountMenuItemText = AccountMenuItemText;
function AccountMenuItemLink(_a) {
    var { href, className, children, active } = _a, props = __rest(_a, ["href", "className", "children", "active"]);
    return (react_1.default.createElement("a", Object.assign({ href: href, className: (0, classnames_1.default)('text-blue underline hover:no-underline', { 'no-underline': active }, className) }, props), children));
}
exports.AccountMenuItemLink = AccountMenuItemLink;
